// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".continue[data-v-28fb4242]{min-width:10rem}.x-icon[data-v-28fb4242]{margin-top:.1rem}.discount-modal-content[data-v-28fb4242]{margin:1rem -1rem 0;width:calc(100% + 2rem)}.discount-modal-content .code[data-v-28fb4242]{text-transform:uppercase}.discount-modal-content button[data-v-28fb4242]{margin-bottom:-1rem}@media screen and (max-width:767px){.discount-modal-content button[data-v-28fb4242]{width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
